// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/tours/icon_close.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tour-step{
    border-radius: 10px;
	border: 1px solid #CDCDCD;
	background: #FFF;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	z-index: 99999999;
	width: 350px;
    font-family: Poppins;
    position: absolute;
}

.step-title{
    border-radius: 10px 10px 0px 0px;
    border-top: 1px solid #FFF;
    border-right: 1px solid #FFF;
    border-left: 1px solid #FFF;
    background: #F89B3C;
    color: #fff;
    padding: 6px 10px;
    font-weight: bold;
}

.step-arrow{
    position: absolute;  
    top: 40px; 
}

.step-arrow.arrow-right{
    left: 342px;
}

.step-arrow.arrow-left{
    right: 342px;
}

.step-arrow img{
    height: 30px;
}

.tour-close-button {
    margin: 5px;
    padding: 11px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
}

.tour-close-button:hover{
    cursor: pointer;
}
  
  .top-right {
    position: absolute;
    right: 0;
    top: 0
  }

.step-content{
    padding: 10px;
    text-align: center;
}

.step-navigation{
    padding: 10px;
    font-weight: 600;
    font-size: 12px;
    height: 55px;
}

.step-navigation .back{
    float: left;
    width: 100px;
}

.step-navigation .next{
    float:right;
    width: 100px;
}

.step-footer{
    text-align: center;
    border-top: #F89B3C dotted 1px;
    margin: 5px 10px;
    padding: 6px;
    color: #828282;
    font-size: 11px;
}

.tour-arrow {
    border: solid #CDCDCD;
    display: inline-block;
    padding: 6px;
    position: absolute;
    background-color: #fff;
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
}

.tour-step .up {
    top: -7px;
    border-width: 0 1px 1px 0;
}

.tour-step .down {
    bottom: -7px;
    border-width: 1px 0 0 1px;
}

.tour-step .left{
    left: 10%;
}

.tour-step .right{
    right: 10%;
}

.tour-intro-modal {
    padding: 0 !important;
}

.tour-modal-dialog {
    border-radius: 10px;
    box-shadow: 1px 1px #C5C5C5;
    font-family: Poppins;
}

.tour-modal-dialog svg {
    fill: var(--main-primary);
}

.tour-modal-dialog a {
    font-family: Poppins !important;
    font-weight: 600 !important;
}

.tour-modal-dialog-titlebar {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 40px;
    background: none !important;
    background-color: var(--accent-green) !important;
    margin: 1px;
    text-align: center;
    padding: 8px !important;
}

.tour-modal-content {
    padding: 0 !important;
    text-align: center;
}

.tour-button {
    border-radius: 5px;
    background: #F89B3C;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    height: 35px;
    line-height: 35px;
    color: #ffffff;
    text-align: center;
}

.tour-link {
    color: #F89B3C;
    margin: 10px 0;
}

.tour-link:hover,
.tour-button:hover {
    cursor: pointer;
}



.tour-overlay:not(.exclude) {
    background-color: rgba(0, 0, 0, 0.1);
    padding-top: 2em;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
}

.exclude {
    background-color: white;
    border: #F89B3C solid 2px;
    border-radius: 5px;
    z-index: 100;
    position: relative;
    z-index: 2;
}

.step-gif{
    margin: 10px 0;
}

.step-gif img{
    width: 300px;
    height: auto;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    border: 1px #eee solid;
    border-radius: 5px;
}

.step-description{
    margin: 10px 0 15px 0;
}

.intro .tour-button, .outro .tour-button{
    border-radius: 12px;
    background: #F89B3C;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    color: #ffffff;
    padding: 9px;
    text-align: center;
    width: 200px;
    height: auto;
    margin: 0 auto;
    font-weight: 600;
}

.intro, .outro{
    text-align: center;
    font-family: Poppins;
}

.intro-content, .outro-content {
    margin: 15px 25px;
    font-size: 16px;
}

.outro-title{
    color: #F89B3C;
    font-size: 25px;
    font-weight: 700;
}

.outro-text{
    margin: 30px 0;
}

.outro-content{
    padding: 20px 40px;
}

.outro-text a{
    color: #F89B3C;
}

.outro-text a:hover{
    text-decoration: none;
    color: #F89B3C;
}

.tour-icon{
    color:#F89B3C;
}

.tour-icon:hover{
    cursor: pointer;
}

.share-email-button {
    font-size: 14px;
    cursor: pointer;
    text-align: center;
    float: right;
    padding: 5px 10px;
    border-radius: 5px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    width: 100px;
}

.email-error{
    color: #AC0000!important;
    text-align: left;
}

.charCounter{
    color: #2d2d2d;
    font-size: 10px;
    width: 100%;
    text-align: right;
}`, "",{"version":3,"sources":["webpack://./assets/style/tours.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;CACtB,yBAAyB;CACzB,gBAAgB;CAChB,+CAA+C;CAC/C,iBAAiB;CACjB,YAAY;IACT,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,6DAA2D;AAC/D;;AAEA;IACI,eAAe;AACnB;;EAEE;IACE,kBAAkB;IAClB,QAAQ;IACR;EACF;;AAEF;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;IACZ,2BAA2B;IAC3B,gDAAgD;IAChD,WAAW;IACX,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,+CAA+C;IAC/C,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;;IAEI,eAAe;AACnB;;;;AAIA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,+CAA+C;IAC/C,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,+CAA+C;IAC/C,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,+CAA+C;IAC/C,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB","sourcesContent":[".tour-step{\r\n    border-radius: 10px;\r\n\tborder: 1px solid #CDCDCD;\r\n\tbackground: #FFF;\r\n\tbox-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n\tz-index: 99999999;\r\n\twidth: 350px;\r\n    font-family: Poppins;\r\n    position: absolute;\r\n}\r\n\r\n.step-title{\r\n    border-radius: 10px 10px 0px 0px;\r\n    border-top: 1px solid #FFF;\r\n    border-right: 1px solid #FFF;\r\n    border-left: 1px solid #FFF;\r\n    background: #F89B3C;\r\n    color: #fff;\r\n    padding: 6px 10px;\r\n    font-weight: bold;\r\n}\r\n\r\n.step-arrow{\r\n    position: absolute;  \r\n    top: 40px; \r\n}\r\n\r\n.step-arrow.arrow-right{\r\n    left: 342px;\r\n}\r\n\r\n.step-arrow.arrow-left{\r\n    right: 342px;\r\n}\r\n\r\n.step-arrow img{\r\n    height: 30px;\r\n}\r\n\r\n.tour-close-button {\r\n    margin: 5px;\r\n    padding: 11px;\r\n    background: url('../images/tours/icon_close.svg') no-repeat;\r\n}\r\n\r\n.tour-close-button:hover{\r\n    cursor: pointer;\r\n}\r\n  \r\n  .top-right {\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0\r\n  }\r\n\r\n.step-content{\r\n    padding: 10px;\r\n    text-align: center;\r\n}\r\n\r\n.step-navigation{\r\n    padding: 10px;\r\n    font-weight: 600;\r\n    font-size: 12px;\r\n    height: 55px;\r\n}\r\n\r\n.step-navigation .back{\r\n    float: left;\r\n    width: 100px;\r\n}\r\n\r\n.step-navigation .next{\r\n    float:right;\r\n    width: 100px;\r\n}\r\n\r\n.step-footer{\r\n    text-align: center;\r\n    border-top: #F89B3C dotted 1px;\r\n    margin: 5px 10px;\r\n    padding: 6px;\r\n    color: #828282;\r\n    font-size: 11px;\r\n}\r\n\r\n.tour-arrow {\r\n    border: solid #CDCDCD;\r\n    display: inline-block;\r\n    padding: 6px;\r\n    position: absolute;\r\n    background-color: #fff;\r\n    transform: rotate(-135deg);\r\n    -webkit-transform: rotate(-135deg);\r\n}\r\n\r\n.tour-step .up {\r\n    top: -7px;\r\n    border-width: 0 1px 1px 0;\r\n}\r\n\r\n.tour-step .down {\r\n    bottom: -7px;\r\n    border-width: 1px 0 0 1px;\r\n}\r\n\r\n.tour-step .left{\r\n    left: 10%;\r\n}\r\n\r\n.tour-step .right{\r\n    right: 10%;\r\n}\r\n\r\n.tour-intro-modal {\r\n    padding: 0 !important;\r\n}\r\n\r\n.tour-modal-dialog {\r\n    border-radius: 10px;\r\n    box-shadow: 1px 1px #C5C5C5;\r\n    font-family: Poppins;\r\n}\r\n\r\n.tour-modal-dialog svg {\r\n    fill: var(--main-primary);\r\n}\r\n\r\n.tour-modal-dialog a {\r\n    font-family: Poppins !important;\r\n    font-weight: 600 !important;\r\n}\r\n\r\n.tour-modal-dialog-titlebar {\r\n    border-top-left-radius: 10px;\r\n    border-top-right-radius: 10px;\r\n    height: 40px;\r\n    background: none !important;\r\n    background-color: var(--accent-green) !important;\r\n    margin: 1px;\r\n    text-align: center;\r\n    padding: 8px !important;\r\n}\r\n\r\n.tour-modal-content {\r\n    padding: 0 !important;\r\n    text-align: center;\r\n}\r\n\r\n.tour-button {\r\n    border-radius: 5px;\r\n    background: #F89B3C;\r\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n    height: 35px;\r\n    line-height: 35px;\r\n    color: #ffffff;\r\n    text-align: center;\r\n}\r\n\r\n.tour-link {\r\n    color: #F89B3C;\r\n    margin: 10px 0;\r\n}\r\n\r\n.tour-link:hover,\r\n.tour-button:hover {\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n\r\n.tour-overlay:not(.exclude) {\r\n    background-color: rgba(0, 0, 0, 0.1);\r\n    padding-top: 2em;\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 1;\r\n}\r\n\r\n.exclude {\r\n    background-color: white;\r\n    border: #F89B3C solid 2px;\r\n    border-radius: 5px;\r\n    z-index: 100;\r\n    position: relative;\r\n    z-index: 2;\r\n}\r\n\r\n.step-gif{\r\n    margin: 10px 0;\r\n}\r\n\r\n.step-gif img{\r\n    width: 300px;\r\n    height: auto;\r\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n    border: 1px #eee solid;\r\n    border-radius: 5px;\r\n}\r\n\r\n.step-description{\r\n    margin: 10px 0 15px 0;\r\n}\r\n\r\n.intro .tour-button, .outro .tour-button{\r\n    border-radius: 12px;\r\n    background: #F89B3C;\r\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n    color: #ffffff;\r\n    padding: 9px;\r\n    text-align: center;\r\n    width: 200px;\r\n    height: auto;\r\n    margin: 0 auto;\r\n    font-weight: 600;\r\n}\r\n\r\n.intro, .outro{\r\n    text-align: center;\r\n    font-family: Poppins;\r\n}\r\n\r\n.intro-content, .outro-content {\r\n    margin: 15px 25px;\r\n    font-size: 16px;\r\n}\r\n\r\n.outro-title{\r\n    color: #F89B3C;\r\n    font-size: 25px;\r\n    font-weight: 700;\r\n}\r\n\r\n.outro-text{\r\n    margin: 30px 0;\r\n}\r\n\r\n.outro-content{\r\n    padding: 20px 40px;\r\n}\r\n\r\n.outro-text a{\r\n    color: #F89B3C;\r\n}\r\n\r\n.outro-text a:hover{\r\n    text-decoration: none;\r\n    color: #F89B3C;\r\n}\r\n\r\n.tour-icon{\r\n    color:#F89B3C;\r\n}\r\n\r\n.tour-icon:hover{\r\n    cursor: pointer;\r\n}\r\n\r\n.share-email-button {\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    text-align: center;\r\n    float: right;\r\n    padding: 5px 10px;\r\n    border-radius: 5px;\r\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n    width: 100px;\r\n}\r\n\r\n.email-error{\r\n    color: #AC0000!important;\r\n    text-align: left;\r\n}\r\n\r\n.charCounter{\r\n    color: #2d2d2d;\r\n    font-size: 10px;\r\n    width: 100%;\r\n    text-align: right;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
